module.exports = __webpack_public_path__ + "static/media/keybase.15351ce5.svg";